import { useState, useRef } from "react";
import { instance } from "utils/axios";

const C = { purple: "#7B2FBE", yellow: "#FFD600", teal: "#00BCD4", orange: "#FF5722", bg: "#f7f4fc", border: "#e8e0f5" };

const ADDRESS_DATA = {
    "Улаанбаатар": ["Баянгол", "Баянзүрх", "Чингэлтэй", "Сүхбаатар", "Хан-Уул", "Сонгинохайрхан", "Налайх", "Багануур", "Багахангай"],
    "Архангай": ["Эрдэнэбулган", "Батцэнгэл", "Булган", "Жаргалант", "Өгийнуур", "Тариат", "Хайрхан", "Хотонт", "Цэцэрлэг", "Чулуут", "Эрдэнэмандал"],
    "Баян-Өлгий": ["Өлгий", "Алтай", "Алтанцөгц", "Бугат", "Булган", "Дэлүүн", "Ногооннуур", "Сагсай", "Толбо", "Цэнгэл"],
    "Баянхонгор": ["Баянхонгор", "Баацагаан", "Баян-Овоо", "Баянбулаг", "Баянговь", "Баянлиг", "Богд", "Бөмбөгөр", "Бууцагаан", "Галуут", "Жаргалант", "Жинст", "Заг", "Өлзийт", "Хүрээмарал", "Шинэжинст", "Эрдэнэцогт"],
    "Булган": ["Булган", "Баяннуур", "Бүрэгхангай", "Гурванбулаг", "Дашинчилэн", "Могод", "Орхон", "Рашаант", "Сайхан", "Сэлэнгэ", "Тэшиг", "Хангал", "Хутаг-Өндөр", "Хялганат"],
    "Говь-Алтай": ["Есөнбулаг", "Алтай", "Баян-Уул", "Бигэр", "Бугат", "Дарив", "Делгэр", "Жаргалан", "Тайшир", "Тонхил", "Төгрөг", "Халиун", "Цогт", "Цээл", "Чандмань", "Шарга", "Эрдэнэ"],
    "Говьсүмбэр": ["Чойр", "Баянтал", "Шивээговь", "Сүмбэр"],
    "Дархан-Уул": ["Дархан", "Орхон", "Хонгор", "Шарын гол"],
    "Дорноговь": ["Сайншанд", "Айраг", "Алтанширээ", "Замын-Үүд", "Иххэт", "Мандах", "Өргөн", "Сайхандулаан", "Улаанбадрах", "Хатанбулаг", "Хөвсгөл", "Эрдэнэ"],
    "Дорнод": ["Чойбалсан", "Баян-Уул", "Баянтүмэн", "Булган", "Гурванзагал", "Дашбалбар", "Матад", "Сэргэлэн", "Халхгол", "Хөлөнбуйр", "Цагаан-Овоо", "Чулуунхороот"],
    "Дундговь": ["Мандалговь", "Адаацаг", "Баянжаргалан", "Говь-Угтаал", "Гурвансайхан", "Дэлгэрхангай", "Дэлгэрцогт", "Дэлгэр", "Луус", "Өлзийт", "Сайнцагаан", "Сэрүүн", "Хулд", "Цагаандэлгэр", "Эрдэнэдалай"],
    "Завхан": ["Улиастай", "Алдархаан", "Асгат", "Баянхайрхан", "Дөрвөлжин", "Завханмандал", "Идэр", "Их-Уул", "Нөмрөг", "Отгон", "Санжит", "Сонгино", "Тосонцэнгэл", "Түдэвтэй", "Тэлмэн", "Тэс", "Ургамал", "Цагаанхайрхан", "Цагаанчулуут", "Шилүүстэй", "Эрдэнэхайрхан"],
    "Орхон": ["Эрдэнэт", "Баян-Өндөр", "Жаргалант"],
    "Өвөрхангай": ["Арвайхээр", "Бат-Өлзий", "Баян-Өндөр", "Баянгол", "Богд", "Бүрд", "Гучин-Ус", "Есөнзүйл", "Зүүнбаян-Улаан", "Нарийнтээл", "Өлзийт", "Санжит", "Тарагт", "Төгрөг", "Уянга", "Хархорин", "Хужирт"],
    "Өмнөговь": ["Даланзадгад", "Баян-Овоо", "Баяндалай", "Булган", "Гурвантэс", "Мандал-Овоо", "Манлай", "Номгон", "Ноён", "Сэврэй", "Ханбогд", "Ханхонгор", "Хүрмэн", "Цогт-Овоо", "Цогтцэций"],
    "Сүхбаатар": ["Баруун-Урт", "Асгат", "Баяндэлгэр", "Дарьганга", "Мөнххаан", "Наран", "Онгон", "Түвшинширээ", "Уулбаян", "Халзан", "Эрдэнэцагаан"],
    "Сэлэнгэ": ["Сүхбаатар", "Алтанбулаг", "Баруунбүрэн", "Баянгол", "Ерөө", "Жавхлант", "Мандал", "Орхон", "Орхонтуул", "Сайхан", "Сант", "Түшиг", "Хушаат", "Цагааннуур", "Шаамар"],
    "Төв": ["Зуунмод", "Алтанбулаг", "Аргалант", "Архуст", "Батсүмбэр", "Баян", "Баяндэлгэр", "Баянжаргалан", "Баян-Өнжүүл", "Борнуур", "Бүрэн", "Дэлгэрхаан", "Жаргалант", "Заамар", "Лүн", "Мөнгөнморьт", "Өндөрширээт", "Сэргэлэн", "Угтаалцайдам", "Цээл", "Эрдэнэ", "Эрдэнэсант"],
    "Увс": ["Улаангом", "Баруунтуруун", "Бөхмөрөн", "Давст", "Завхан", "Зүүнговь", "Зүүнхангай", "Малчин", "Наранбулаг", "Өлгий", "Сагил", "Тариалан", "Түргэн", "Тэс", "Ховд", "Хяргас", "Цагаанхайрхан"],
    "Ховд": ["Ховд", "Алтай", "Булган", "Буянт", "Дарви", "Дөргөн", "Дуут", "Зэрэг", "Манхан", "Мөст", "Мянгад", "Үенч", "Цэцэг", "Чандмань", "Эрдэнэбүрэн"],
    "Хөвсгөл": ["Мөрөн", "Алаг-Эрдэнэ", "Арбулаг", "Баянзүрх", "Бүрэнтогтох", "Галт", "Жаргалант", "Их-Уул", "Рашаант", "Рэнчинлхүмбэ", "Тариалан", "Төмөрбулаг", "Тунхэл", "Улаан-Уул", "Ханх", "Хатгал", "Цагаан-Уул", "Цагааннуур", "Цэцэрлэг", "Чандмань-Өндөр", "Шинэ-Идэр", "Эрдэнэбулган"],
    "Хэнтий": ["Өндөрхаан", "Батноров", "Батширээт", "Баян-Адрага", "Баянмөнх", "Баян-Овоо", "Биндэр", "Галшар", "Дадал", "Дархан", "Дэлгэрхаан", "Жаргалтхаан", "Мөрөн", "Норовлин", "Өлзийт", "Цэнхэрмандал", "Хэрлэн"],
    "Гадаадад": ["Орос", "Солонгос", "АНУ", "Хятад", "Япон", "Герман", "Австрали", "Бусад"],
};

const GRADES = [5, 6, 7, 8, 9, 10];
const SCHOOL_LOCATIONS = ["Улаанбаатар хот", "21 аймаг", "Гадаадад"];
const GPA_RANGES = ["60+", "65+", "70+", "75+", "80+", "85+", "90+", "95+", "100"];

function parseRD(reg) {
    if (!reg) return null;

    const chars = [...reg.trim()];
    const letters = chars.filter(c => !/\d/.test(c));
    const digits = chars.filter(c => /\d/.test(c)).join("");

    if (letters.length !== 2 || digits.length !== 8) return null;

    const yy = parseInt(digits.slice(0, 2), 10);
    const mmRaw = parseInt(digits.slice(2, 4), 10);
    const dd = parseInt(digits.slice(4, 6), 10);
    const gDigit = parseInt(digits[6], 10);

    if (isNaN(yy) || isNaN(mmRaw) || isNaN(dd) || isNaN(gDigit)) return null;
    if (dd < 1 || dd > 31) return null;

    let year = 2000 + yy;
    if (year > new Date().getFullYear()) year -= 100;

    let month;
    if (year < 2000) {
        if (mmRaw >= 1 && mmRaw <= 12) month = mmRaw;
        else return null;
    } else {
        if (mmRaw >= 21 && mmRaw <= 32) month = mmRaw - 20;
        else return null;
    }

    const gender = gDigit % 2 !== 0 ? "Эрэгтэй" : "Эмэгтэй";
    const birthDate = `${year}-${String(month).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;

    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    if (
        today.getMonth() < birth.getMonth() ||
        (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())
    ) {
        age--;
    }

    return { birthDate, gender, age };
}

const inputStyle = (err) => ({
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: `1.5px solid ${err ? "#e53935" : C.border}`,
    fontSize: 15,
    outline: "none",
    fontFamily: "inherit",
    boxSizing: "border-box",
    background: "#fafafa",
});

function AutoTag() {
    return (
        <span
            style={{
                marginLeft: 8,
                fontSize: 10,
                fontWeight: 700,
                color: "#16a34a",
                background: "#dcfce7",
                padding: "2px 7px",
                borderRadius: 99,
                verticalAlign: "middle",
            }}
        >
            РД-аас ✓
        </span>
    );
}

function Label({ children, required }) {
    return (
        <label style={{ display: "block", fontSize: 13, fontWeight: 700, color: "#444", marginBottom: 7 }}>
            {children}
            {required && <span style={{ color: "#e53935", marginLeft: 3 }}>*</span>}
        </label>
    );
}

function ErrMsg({ msg = "Заавал бөглөнө үү" }) {
    return <div style={{ color: "#e53935", fontSize: 12, marginTop: 5 }}>⚠ {msg}</div>;
}

function SubLabel({ children }) {
    return <div style={{ fontSize: 13, fontWeight: 600, color: "#666", marginBottom: 6 }}>{children}</div>;
}

function Divider({ title }) {
    return (
        <div style={{ margin: "24px 0 18px", paddingBottom: 8, borderBottom: `2px solid ${C.border}` }}>
            <div
                style={{
                    fontSize: 12,
                    fontWeight: 800,
                    color: C.purple,
                    textTransform: "uppercase",
                    letterSpacing: 1.5,
                }}
            >
                {title}
            </div>
        </div>
    );
}

function PhotoUpload({ value, onChange, error, existingUrl, regNum }) {
    const ref = useRef();
    const [localPreview, setLocalPreview] = useState(null);
    const [uploading, setUploading] = useState(false);

    const preview = localPreview || existingUrl || null;

    const handleFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (ev) => setLocalPreview(ev.target.result);
        reader.readAsDataURL(file);

        setUploading(true);
        try {
            const fd = new FormData();
            fd.append("image", file);
            if (regNum.length === 10) fd.append("regno", regNum);

            const res = await instance.post("applicant2/photo", fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            onChange(res.data.url);
        } catch {
            onChange(null);
        } finally {
            setUploading(false);
        }
    };

    return (
        <div>
            <Label required>Өөрийн цээж зураг</Label>

            <div
                onClick={() => !uploading && ref.current?.click()}
                style={{
                    minHeight: 100,
                    borderRadius: 12,
                    border: `2px dashed ${error ? "#e53935" : preview ? C.purple : C.border}`,
                    background: preview ? "#f3eaff" : "#fafafa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: uploading ? "not-allowed" : "pointer",
                    padding: 16,
                    boxSizing: "border-box",
                    gap: 14,
                    transition: "all 0.2s",
                }}
            >
                {uploading ? (
                    <div style={{ textAlign: "center", color: C.purple, fontSize: 13, fontWeight: 700 }}>
                        ⏳ Зураг хуулж байна...
                    </div>
                ) : preview ? (
                    <>
                        <img
                            src={preview}
                            alt="preview"
                            style={{
                                width: 68,
                                height: 68,
                                borderRadius: 50,
                                objectFit: "cover",
                                border: `3px solid ${C.purple}`,
                            }}
                        />
                        <div style={{ fontSize: 13, color: C.purple, fontWeight: 700 }}>
                            ✅ Зураг хуулагдлаа
                            <br />
                            <span style={{ color: "#aaa", fontWeight: 400, fontSize: 12 }}>
                                Өөрчлөхийн тулд дарна уу
                            </span>
                        </div>
                    </>
                ) : (
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontSize: 26, marginBottom: 4 }}>📷</div>
                        <div style={{ fontSize: 13, fontWeight: 600, color: "#666" }}>Цээж зураг оруулах</div>
                        <div style={{ fontSize: 11, color: "#bbb", marginTop: 2 }}>JPG, PNG</div>
                    </div>
                )}
            </div>

            <input ref={ref} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFile} />
            {error && <ErrMsg msg="Цээж зураг оруулна уу" />}
        </div>
    );
}

export function AddressField({ value = {}, onChange, errors = {} }) {
    const aimags = Object.keys(ADDRESS_DATA);
    const sums = value.aimag ? (ADDRESS_DATA[value.aimag] || []) : [];
    const isUB = value.aimag === "Улаанбаатар";

    const set = (key, val) => {
        const next = { ...value, [key]: val };
        if (key === "aimag") {
            next.sum = "";
            next.khoroo = "";
            next.detail = "";
        }
        onChange(next);
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div>
                <SubLabel>{isUB ? "🏙 Хот" : "🗺 Аймаг"}</SubLabel>
                <select value={value.aimag || ""} onChange={(e) => set("aimag", e.target.value)} style={inputStyle(errors.aimag)}>
                    <option value="">Хот / Аймаг сонгоно уу...</option>
                    {aimags.map((a) => (
                        <option key={a} value={a}>
                            {a}
                        </option>
                    ))}
                </select>
                {errors.aimag && <ErrMsg />}
            </div>

            {value.aimag && (
                <div style={{ animation: "fadeIn 0.2s ease" }}>
                    <SubLabel>{isUB ? "🏢 Дүүрэг" : "🏘 Сум"}</SubLabel>
                    <select value={value.sum || ""} onChange={(e) => set("sum", e.target.value)} style={inputStyle(errors.sum)}>
                        <option value="">{isUB ? "Дүүрэг сонгоно уу..." : "Сум сонгоно уу..."}</option>
                        {sums.map((s) => (
                            <option key={s} value={s}>
                                {s}
                            </option>
                        ))}
                    </select>
                    {errors.sum && <ErrMsg />}
                </div>
            )}

            {value.sum && (
                <div style={{ animation: "fadeIn 0.2s ease" }}>
                    <SubLabel>{isUB ? "🏠 Хороо" : "🌿 Баг"}</SubLabel>
                    <input
                        type="text"
                        value={value.khoroo || ""}
                        onChange={(e) => set("khoroo", e.target.value)}
                        placeholder={isUB ? "Жишээ: 3-р хороо" : "Жишээ: 2-р баг"}
                        style={inputStyle(false)}
                    />
                </div>
            )}

            {value.sum && (
                <div style={{ animation: "fadeIn 0.2s ease" }}>
                    <SubLabel>📍 Дэлгэрэнгүй хаяг</SubLabel>
                    <input
                        type="text"
                        value={value.detail || ""}
                        onChange={(e) => set("detail", e.target.value)}
                        placeholder="Байр, тоот, гудамж..."
                        style={inputStyle(false)}
                    />
                </div>
            )}

            <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}`}</style>
        </div>
    );
}

export default function GeneralInfo({ onNext, initialData }) {
    const [data, setData] = useState(initialData || {});
    const [errors, setErrors] = useState({});
    const [regNum, setRegNum] = useState(initialData?.regNum || "");
    const [parsed, setParsed] = useState(initialData?.regNum ? parseRD(initialData.regNum) : null);
    const [searching, setSearching] = useState(false);
    const [found, setFound] = useState(initialData ? true : null);
    const [submitting, setSubmitting] = useState(false);

    const set = (key, val) => {
        setData((p) => ({ ...p, [key]: val }));
        if (errors[key]) setErrors((p) => ({ ...p, [key]: false }));
    };

    const handleRD = async (val) => {
        const v = val.toUpperCase().replace(/\s/g, "");
        setRegNum(v);
        setFound(null);

        if (errors.regNum) {
            setErrors((prev) => ({ ...prev, regNum: false }));
        }

        if (v.length === 10) {
            const p = parseRD(v);
            setParsed(p);

            if (p) {
                setData((prev) => ({
                    ...prev,
                    regNum: v,
                    birthDate: p.birthDate,
                    gender: p.gender,
                }));
            } else {
                setData((prev) => ({ ...prev, regNum: v }));
                setSearching(false);
                return;
            }

            setSearching(true);

            try {
                const res = await instance.post("applicant2", { regno: v });
                const ex = res.data;

                if (ex?.exists) {
                    setFound(true);

                    const gradeNum = ex.grade ? parseInt(ex.grade, 10) : null;
                    setData((prev) => {
                        const graduatingGrade =
                            gradeNum && !isNaN(gradeNum) ? gradeNum - 1 : prev.graduatingGrade;

                        return {
                            ...prev,
                            firstName: ex.firstName || prev.firstName,
                            lastName: ex.lastName || prev.lastName,
                            phone: ex.mobile || prev.phone,
                            email: ex.email || prev.email,
                            instagram: ex.instagram || prev.instagram,
                            graduatingGrade: graduatingGrade || prev.graduatingGrade,
                            school: ex.school || prev.school,
                            schoolLocation: ex.schoolLocation || prev.schoolLocation,
                            prevYearGpa: ex.prevYearGpa || prev.prevYearGpa,
                            curHalfGpa: ex.curHalfGpa || prev.curHalfGpa,
                            gender: ex.gender || prev.gender,
                            birthDate: ex.birthDate ? ex.birthDate.slice(0, 10) : prev.birthDate,
                            photoUrl: ex.photoUrl || prev.photoUrl,
                            address:
                                ex.addressCity || ex.addressDistrict
                                    ? {
                                        aimag: ex.addressCity || "",
                                        sum: ex.addressDistrict || "",
                                        khoroo: ex.addressKhoroo || "",
                                        detail: ex.addressDetail || "",
                                    }
                                    : prev.address,
                        };
                    });
                } else {
                    setFound(false);
                }
            } catch {
                setFound(false);
            } finally {
                setSearching(false);
            }
        } else {
            setParsed(null);
            setSearching(false);
            setData((prev) => ({ ...prev, regNum: v }));
        }
    };

    const validate = () => {
        const e = {};

        ["regNum", "lastName", "firstName", "birthDate", "gender", "phone", "email","instagram", "graduatingGrade", "schoolLocation", "school", "prevYearGpa", "curHalfGpa"].forEach((k) => {
            if (!data[k] || data[k].toString().trim() === "") e[k] = true;
        });

        if (!data.photo && !data.photoUrl) e.photo = true;

        const addr = data.address || {};
        const ae = {};
        if (!addr.aimag) ae.aimag = true;
        if (!addr.sum) ae.sum = true;
        if (Object.keys(ae).length) e.address = ae;

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleNext = async () => {
        if (!validate()) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }

        setSubmitting(true);
        try {
            const res = await instance.post("applicant2/register", {
                regno: data.regNum,
                lastName: data.lastName,
                firstName: data.firstName,
                email: data.email,
                mobile: data.phone,
                instagram: data.instagram || "",
                gender: data.gender || "",
                birthDate: data.birthDate || "",
                graduatingGrade: data.graduatingGrade || "",
                school: data.school || "",
                schoolLocation: data.schoolLocation || "",
                prevYearGpa: data.prevYearGpa || "",
                curHalfGpa: data.curHalfGpa || "",
                addressCity: data.address?.aimag || "",
                addressDistrict: data.address?.sum || "",
                addressKhoroo: data.address?.khoroo || "",
                addressDetail: data.address?.detail || "",
                photoUrl: data.photo || data.photoUrl || "",
            });

            onNext(data, res.data);
        } finally {
            setSubmitting(false);
        }
    };

    const rdReady = regNum.length === 10 && !!parsed && !searching;
    const inp = (key) => inputStyle(errors[key]);

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "28px 16px 60px", width: "100%" }}>
            <div
                style={{
                    background: "#fff",
                    borderRadius: 16,
                    boxShadow: "0 2px 20px rgba(0,0,0,0.07)",
                    padding: "24px 28px",
                    marginBottom: 18,
                    borderTop: `4px solid ${C.purple}`,
                    width: "100%",
                    maxWidth: 660,
                    boxSizing: "border-box",
                }}
            >
                <h2 style={{ fontSize: 20, fontWeight: 800, color: "#1a1a2e", margin: "0 0 6px" }}>Ерөнхий мэдээлэл</h2>
                <p style={{ color: "#888", fontSize: 13, margin: 0 }}>
                    Бүх талбарыг үнэн зөвөөр бөглөнө үү. <span style={{ color: "#e53935" }}>*</span> тэмдэгтэй талбар заавал шаардлагатай.
                </p>
            </div>

            {/* РД талбар always enabled */}
            <div style={{ width: "100%", maxWidth: 660, marginBottom: 18 }}>
                <Label required>Регистрийн дугаар</Label>

                <div style={{ position: "relative" }}>
                    <input
                        value={regNum}
                        onChange={(e) => handleRD(e.target.value)}
                        placeholder="АА19900112"
                        maxLength={10}
                        style={{
                            ...inp("regNum"),
                            fontFamily: "monospace",
                            fontSize: 16,
                            letterSpacing: 3,
                            paddingRight: 40,
                        }}
                    />

                    <div style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", fontSize: 16 }}>
                        {searching ? (
                            <span style={{ animation: "spin 1s linear infinite", display: "inline-block" }}>⏳</span>
                        ) : regNum.length === 10 ? (
                            found === true ? "✅" : found === false ? "🔍" : null
                        ) : (
                            <span style={{ color: "#ccc", fontSize: 12, fontWeight: 700 }}>{regNum.length}/10</span>
                        )}
                    </div>
                </div>

                <style>{`@keyframes spin{from{transform:translateY(-50%) rotate(0deg)}to{transform:translateY(-50%) rotate(360deg)}}`}</style>

                {parsed && !searching && (
                    <div
                        style={{
                            marginTop: 8,
                            padding: "10px 14px",
                            borderRadius: 10,
                            background: "#f0fdf4",
                            border: "1.5px solid #86efac",
                            fontSize: 13,
                        }}
                    >
                        ✅ &nbsp;Төрсөн: <strong>{parsed.birthDate}</strong> &nbsp;·&nbsp; Хүйс: <strong>{parsed.gender}</strong> &nbsp;·&nbsp; Нас: <strong>{parsed.age}</strong>
                    </div>
                )}

                {regNum.length === 10 && !parsed && !searching && (
                    <div
                        style={{
                            marginTop: 6,
                            padding: "8px 14px",
                            borderRadius: 10,
                            background: "#fef2f2",
                            border: "1.5px solid #fca5a5",
                            fontSize: 13,
                            color: "#b91c1c",
                        }}
                    >
                        ⚠️ Регистрийн дугаарын формат буруу байна
                    </div>
                )}

                {found === true && (
                    <div
                        style={{
                            marginTop: 6,
                            padding: "8px 14px",
                            borderRadius: 10,
                            background: "#fffbeb",
                            border: "1.5px solid #fcd34d",
                            fontSize: 13,
                            color: "#92400e",
                        }}
                    >
                        ⚡ Өмнөх өргөдөл олдлоо — мэдээлэл автоматаар бөглөгдлөө
                    </div>
                )}

                {found === false && parsed && (
                    <div
                        style={{
                            marginTop: 6,
                            padding: "8px 14px",
                            borderRadius: 10,
                            background: "#f0f9ff",
                            border: "1.5px solid #bae6fd",
                            fontSize: 13,
                            color: "#0369a1",
                        }}
                    >
                        ℹ️ Шинэ өргөдөл — мэдээллээ гараар бөглөнө үү
                    </div>
                )}

                {errors.regNum && <ErrMsg />}
            </div>

            {/* Бусад талбарууд зөв РД орсны дараа идэвхжинэ */}
            <div
                style={{
                    width: "100%",
                    maxWidth: 660,
                    display: "flex",
                    flexDirection: "column",
                    gap: 18,
                    opacity: rdReady ? 1 : 0.6,
                    pointerEvents: rdReady ? "auto" : "none",
                    transition: "opacity 0.3s",
                }}
            >
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <div>
                        <Label required>Овог</Label>
                        <input value={data.lastName || ""} onChange={(e) => set("lastName", e.target.value)} placeholder="Овгоо оруулна уу" style={inp("lastName")} />
                        {errors.lastName && <ErrMsg />}
                    </div>
                    <div>
                        <Label required>Нэр</Label>
                        <input value={data.firstName || ""} onChange={(e) => set("firstName", e.target.value)} placeholder="Нэрээ оруулна уу" style={inp("firstName")} />
                        {errors.firstName && <ErrMsg />}
                    </div>
                </div>

                <PhotoUpload
                    value={data.photo}
                    onChange={(v) => set("photo", v)}
                    error={errors.photo}
                    existingUrl={data.photoUrl ? `${process.env.REACT_APP_CDN_URL}${data.photoUrl}` : null}
                    regNum={regNum}
                />

                <div>
                    <Label required>
                        Төрсөн он, сар, өдөр
                        {parsed && data.birthDate && <AutoTag />}
                    </Label>
                    <input
                        type="text"
                        value={data.birthDate || ""}
                        onChange={(e) => set("birthDate", e.target.value)}
                        placeholder="1990-05-12"
                        style={{
                            ...inp("birthDate"),
                            background: parsed && data.birthDate ? "#f0fdf4" : "#fafafa",
                            borderColor: parsed && data.birthDate ? "#86efac" : errors.birthDate ? "#e53935" : C.border,
                        }}
                    />
                    {parsed && data.birthDate && <div style={{ fontSize: 12, color: "#16a34a", marginTop: 4 }}>🎂 {parsed.age} нас</div>}
                    {errors.birthDate && <ErrMsg />}
                </div>

                <div>
                    <Label required>
                        Хүйс
                        {parsed && data.gender && <AutoTag />}
                    </Label>
                    <div style={{ display: "flex", gap: 10 }}>
                        {["Эрэгтэй", "Эмэгтэй"].map((opt) => (
                            <label
                                key={opt}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    cursor: "pointer",
                                    padding: "10px 20px",
                                    borderRadius: 50,
                                    border: `1.5px solid ${data.gender === opt ? C.purple : C.border}`,
                                    background: data.gender === opt ? "#f3eaff" : "#fff",
                                    fontSize: 14,
                                    fontWeight: data.gender === opt ? 700 : 400,
                                    transition: "all 0.15s",
                                }}
                            >
                                <input
                                    type="radio"
                                    name="gender"
                                    checked={data.gender === opt}
                                    onChange={() => set("gender", opt)}
                                    style={{ accentColor: C.purple, width: 15, height: 15 }}
                                />
                                {opt}
                            </label>
                        ))}
                    </div>
                    {errors.gender && <ErrMsg />}
                </div>

                <div>
                    <Label required>Утасны дугаар</Label>
                    <input
                        type="tel"
                        value={data.phone || ""}
                        onChange={(e) => set("phone", e.target.value.replace(/\D/g, ""))}
                        placeholder="99001234"
                        maxLength={8}
                        style={inp("phone")}
                    />
                    {errors.phone && <ErrMsg />}
                </div>
                <div>
                    <Label required>И-мэйл хаяг</Label>
                    <input
                        type="email"
                        value={data.email || ""}
                        onChange={(e) => set("email", e.target.value)}
                        placeholder="name@example.com"
                        style={inp("email")}
                    />
                    {errors.email && <ErrMsg msg="И-мэйл хаягаа оруулна уу" />}
                </div>
                <div>
                    <Label required>Инстаграм хаяг</Label>
                    <div style={{ position: "relative" }}>
                        <span
                            style={{
                                position: "absolute",
                                left: 13,
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#bbb",
                                fontSize: 15,
                                pointerEvents: "none",
                            }}
                        >
                            @
                        </span>
                        <input
                            value={(data.instagram || "").replace(/^@/, "")}
                            onChange={(e) => set("instagram", "@" + e.target.value.replace(/^@/, ""))}
                            placeholder="username"
                            style={{ ...inp("instagram"), paddingLeft: 30 }}
                        />
                    </div>
                    {errors.instagram && <ErrMsg />}
                </div>

                <div>
                    <Label required>Оршин суугаа хаяг</Label>
                    <AddressField value={data.address || {}} onChange={(val) => set("address", val)} errors={errors.address || {}} />
                </div>

                <Divider title="Сургуулийн мэдээлэл" />

                <div>
                    <Label required>2025-2026 оны хичээлийн жилд төгсөж буй анги</Label>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        {GRADES.map((g) => (
                            <button
                                key={g}
                                type="button"
                                onClick={() => set("graduatingGrade", g)}
                                style={{
                                    padding: "9px 18px",
                                    borderRadius: 50,
                                    border: `1.5px solid ${data.graduatingGrade === g ? C.purple : C.border}`,
                                    background: data.graduatingGrade === g ? "#f3eaff" : "#fff",
                                    color: data.graduatingGrade === g ? C.purple : "#555",
                                    fontWeight: data.graduatingGrade === g ? 800 : 400,
                                    fontSize: 14,
                                    cursor: "pointer",
                                    transition: "all 0.15s",
                                    fontFamily: "inherit",
                                }}
                            >
                                {g}-р анги
                            </button>
                        ))}
                    </div>
                    {errors.graduatingGrade && <ErrMsg />}
                </div>

                <div>
                    <Label required>Одоо суралцаж буй сургуулийн байршил</Label>
                    <div style={{ display: "flex", gap: 10 }}>
                        {SCHOOL_LOCATIONS.map((opt) => (
                            <label
                                key={opt}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    cursor: "pointer",
                                    padding: "10px 18px",
                                    borderRadius: 50,
                                    border: `1.5px solid ${data.schoolLocation === opt ? C.purple : C.border}`,
                                    background: data.schoolLocation === opt ? "#f3eaff" : "#fff",
                                    fontSize: 14,
                                    fontWeight: data.schoolLocation === opt ? 700 : 400,
                                    transition: "all 0.15s",
                                }}
                            >
                                <input
                                    type="radio"
                                    name="schoolLocation"
                                    checked={data.schoolLocation === opt}
                                    onChange={() => set("schoolLocation", opt)}
                                    style={{ accentColor: C.purple, width: 15, height: 15 }}
                                />
                                {opt}
                            </label>
                        ))}
                    </div>
                    {errors.schoolLocation && <ErrMsg />}
                </div>

                <div>
                    <Label required>Одоо суралцаж буй сургууль</Label>
                    <input value={data.school || ""} onChange={(e) => set("school", e.target.value)} placeholder="Сургуулийн нэр" style={inp("school")} />
                    {errors.school && <ErrMsg />}
                </div>

                <div>
                    <Label required>2024-2025 хичээлийн жилийн дүнгийн голч</Label>
                    <select value={data.prevYearGpa || ""} onChange={(e) => set("prevYearGpa", e.target.value)} style={inp("prevYearGpa")}>
                        <option value="">Сонгоно уу...</option>
                        {GPA_RANGES.map((r) => (
                            <option key={r} value={r}>
                                {r}
                            </option>
                        ))}
                    </select>
                    {errors.prevYearGpa && <ErrMsg />}
                </div>

                <div>
                    <Label required>2025-2026 хичээлийн эхний хагасын дүнгийн дундаж</Label>
                    <select value={data.curHalfGpa || ""} onChange={(e) => set("curHalfGpa", e.target.value)} style={inp("curHalfGpa")}>
                        <option value="">Сонгоно уу...</option>
                        {GPA_RANGES.map((r) => (
                            <option key={r} value={r}>
                                {r}
                            </option>
                        ))}
                    </select>
                    {errors.curHalfGpa && <ErrMsg />}
                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", maxWidth: 660, marginTop: 28 }}>
                <button
                    onClick={handleNext}
                    disabled={submitting}
                    style={{
                        background: C.purple,
                        color: "#fff",
                        border: "none",
                        borderRadius: 50,
                        padding: "13px 40px",
                        fontSize: 15,
                        fontWeight: 800,
                        cursor: "pointer",
                        boxShadow: "0 4px 18px rgba(123,47,190,0.28)",
                        fontFamily: "inherit",
                        opacity: submitting ? 0.7 : 1,
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                    {submitting ? "Хадгалж байна..." : "Үргэлжлүүлэх →"}
                </button>
            </div>
        </div>
    );
}